var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.classes,attrs:{"to":_vm.to,"tag":_vm.tag,"title":_vm.title}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.displayText))]}),(_vm.showIcon)?_c('v-icon',{staticClass:"cross-page-link-icon"},[_vm._v(" mdi-launch ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }